import React from 'react';

const icon_chat = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V12C1.5 12.825 2.175 13.5 3 13.5H13.5L16.5 16.5V3C16.5 2.175 15.825 1.5 15 1.5ZM12.75 10.5H5.25C4.8375 10.5 4.5 10.1625 4.5 9.75C4.5 9.3375 4.8375 9 5.25 9H12.75C13.1625 9 13.5 9.3375 13.5 9.75C13.5 10.1625 13.1625 10.5 12.75 10.5ZM12.75 8.25H5.25C4.8375 8.25 4.5 7.9125 4.5 7.5C4.5 7.0875 4.8375 6.75 5.25 6.75H12.75C13.1625 6.75 13.5 7.0875 13.5 7.5C13.5 7.9125 13.1625 8.25 12.75 8.25ZM12.75 6H5.25C4.8375 6 4.5 5.6625 4.5 5.25C4.5 4.8375 4.8375 4.5 5.25 4.5H12.75C13.1625 4.5 13.5 4.8375 13.5 5.25C13.5 5.6625 13.1625 6 12.75 6Z"
      fill="#A6B0CF"
    />
  </svg>
);

const icon_eye = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_90_2769)">
      <path
        d="M8.50385 11.6363C6.6076 11.6363 5.0726 10.1685 4.93135 8.30855L2.30885 6.2818C1.9641 6.7143 1.64685 7.17155 1.39085 7.67155C1.33366 7.78467 1.30387 7.90966 1.30387 8.03642C1.30387 8.16318 1.33366 8.28817 1.39085 8.4013C2.7466 11.0465 5.4306 12.8363 8.50385 12.8363C9.1766 12.8363 9.8256 12.7363 10.4511 12.5748L9.15385 11.571C8.93961 11.6124 8.72205 11.6343 8.50385 11.6363ZM16.3494 13.0888L13.5856 10.9528C14.4251 10.2453 15.1156 9.37787 15.6169 8.40105C15.674 8.28792 15.7038 8.16293 15.7038 8.03617C15.7038 7.90941 15.674 7.78442 15.6169 7.6713C14.2611 5.02605 11.5771 3.2363 8.50385 3.2363C7.21673 3.23786 5.95051 3.56189 4.82085 4.1788L1.64035 1.72055C1.59888 1.68827 1.55145 1.66449 1.50078 1.65055C1.45011 1.63662 1.39719 1.6328 1.34505 1.63932C1.2929 1.64585 1.24255 1.66258 1.19688 1.68857C1.1512 1.71456 1.1111 1.7493 1.07885 1.7908L0.588102 2.42255C0.523002 2.50629 0.493831 2.61247 0.507005 2.71772C0.520179 2.82297 0.574619 2.91868 0.658352 2.9838L15.3674 14.352C15.4088 14.3843 15.4563 14.4081 15.5069 14.422C15.5576 14.436 15.6105 14.4398 15.6627 14.4333C15.7148 14.4267 15.7652 14.41 15.8108 14.384C15.8565 14.358 15.8966 14.3233 15.9289 14.2818L16.4199 13.65C16.4849 13.5663 16.5141 13.4601 16.5008 13.3548C16.4876 13.2496 16.4331 13.1539 16.3494 13.0888ZM11.7564 9.5388L10.7739 8.7793C10.8566 8.54016 10.9005 8.28932 10.9039 8.0363C10.9087 7.66586 10.8267 7.29945 10.6642 6.96648C10.5018 6.63352 10.2636 6.34329 9.96864 6.1191C9.67371 5.89492 9.33031 5.74302 8.96602 5.67563C8.60174 5.60824 8.22672 5.62722 7.8711 5.73105C8.02185 5.93532 8.1034 6.18242 8.10385 6.4363C8.10012 6.52078 8.08721 6.60461 8.06535 6.6863L6.2251 5.26405C6.86435 4.72985 7.67078 4.43691 8.50385 4.4363C8.97668 4.43603 9.44493 4.52897 9.88182 4.70979C10.3187 4.89062 10.7157 5.15578 11.05 5.49013C11.3844 5.82447 11.6495 6.22143 11.8304 6.65833C12.0112 7.09522 12.1041 7.56346 12.1039 8.0363C12.1039 8.57705 11.9716 9.08105 11.7564 9.53905V9.5388Z"
        fill="#9AB1CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_90_2769">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.503906 0.0361328)"
        />
      </clipPath>
    </defs>
  </svg>
);

const icon_export_result = (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.42674V0.962409C8.00032 0.772097 8.05913 0.586134 8.16902 0.427956C8.27891 0.269778 8.43496 0.146463 8.6175 0.0735515C8.80004 0.000639727 9.00091 -0.0186063 9.1948 0.0182393C9.38868 0.0550849 9.5669 0.146373 9.707 0.2806L16 6.25895L9.707 12.2363C9.61435 12.3261 9.50419 12.3973 9.38285 12.4459C9.26152 12.4945 9.13141 12.5195 9 12.5195C8.86859 12.5195 8.73848 12.4945 8.61715 12.4459C8.49581 12.3973 8.38565 12.3261 8.293 12.2363C8.20009 12.147 8.12639 12.0408 8.07611 11.924C8.02584 11.8072 7.99997 11.682 8 11.5555V9.15856C5.25 9.22405 2.245 9.70363 0 13V12.037C0 7.57538 3.5 3.90632 8 3.42674Z"
      fill="white"
    />
  </svg>
);

const icon_email = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6673 2.66699H3.33398C2.80355 2.66699 2.29484 2.87771 1.91977 3.25278C1.5447 3.62785 1.33398 4.13656 1.33398 4.66699V11.3337C1.33398 11.8641 1.5447 12.3728 1.91977 12.7479C2.29484 13.1229 2.80355 13.3337 3.33398 13.3337H12.6673C13.1978 13.3337 13.7065 13.1229 14.0815 12.7479C14.4566 12.3728 14.6673 11.8641 14.6673 11.3337V4.66699C14.6673 4.13656 14.4566 3.62785 14.0815 3.25278C13.7065 2.87771 13.1978 2.66699 12.6673 2.66699ZM12.6673 4.00033L8.33398 6.98033C8.23264 7.03884 8.11768 7.06964 8.00065 7.06964C7.88363 7.06964 7.76866 7.03884 7.66732 6.98033L3.33398 4.00033H12.6673Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_upload = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17:6038)">
      <path
        d="M7.007 3.993L7.031 11H8.938L8.986 3.986L11.5 6.5L13 5L8 0L3 5L4.5 6.5L7.007 3.993Z"
        fill="white"
      />
      <path d="M14 11V14H2V11H0V17H16V11H14Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_17:6038">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const icon_download = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17:6044)">
      <path
        d="M8.993 7.007L8.969 0H7.062L7.014 7.014L4.5 4.5L3 6L8 11L13 6L11.5 4.5L8.993 7.007Z"
        fill="white"
      />
      <path d="M14 11V14H2V11H0V17H16V11H14Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_17:6044">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const icon_plus = (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.03906 5.61328H12.4922V8.21484H8.03906V13.2891H5.27344V8.21484H0.796875V5.61328H5.27344V0.867188H8.03906V5.61328Z"
      fill="white"
    />
  </svg>
);

const icon_refuse = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.93069 0.738063C9.85516 0.662513 9.76548 0.602599 9.66677 0.561749C9.56806 0.5209 9.46227 0.499916 9.35544 0.5H4.64456C4.42925 0.5 4.22206 0.585313 4.07013 0.738063L0.738876 4.07013C0.663005 4.14529 0.60282 4.23477 0.561813 4.33338C0.520807 4.43199 0.499796 4.53777 0.500001 4.64456V9.35625C0.500001 9.57156 0.585314 9.77875 0.738064 9.93069L4.06931 13.2628C4.22206 13.4147 4.42844 13.5 4.64456 13.5H9.35625C9.57156 13.5 9.77875 13.4147 9.93069 13.2619L13.2619 9.92988C13.4147 9.77794 13.5 9.57156 13.5 9.35544V4.64456C13.5 4.42925 13.4147 4.22206 13.2619 4.07013L9.93069 0.738063ZM7 8.625C6.78451 8.625 6.57785 8.5394 6.42548 8.38702C6.2731 8.23465 6.1875 8.02799 6.1875 7.8125V2.9375C6.1875 2.72201 6.2731 2.51535 6.42548 2.36298C6.57785 2.2106 6.78451 2.125 7 2.125C7.21549 2.125 7.42215 2.2106 7.57453 2.36298C7.7269 2.51535 7.8125 2.72201 7.8125 2.9375V7.8125C7.8125 8.02799 7.7269 8.23465 7.57453 8.38702C7.42215 8.5394 7.21549 8.625 7 8.625ZM7.8125 11.0625C7.81247 11.1692 7.79143 11.2749 7.75056 11.3735C7.70969 11.4721 7.64981 11.5617 7.57432 11.6371C7.49884 11.7126 7.40923 11.7724 7.31062 11.8132C7.21201 11.854 7.10632 11.875 6.9996 11.875C6.89287 11.875 6.78719 11.8539 6.6886 11.8131C6.59001 11.7722 6.50043 11.7123 6.42499 11.6368C6.34954 11.5613 6.2897 11.4717 6.24888 11.3731C6.20806 11.2745 6.18707 11.1688 6.1871 11.0621C6.18715 10.8466 6.27282 10.6399 6.42527 10.4875C6.57772 10.3351 6.78446 10.2495 7 10.2496C7.21554 10.2496 7.42224 10.3353 7.57461 10.4878C7.72698 10.6402 7.81256 10.847 7.8125 11.0625Z"
      fill="#A6B0CF"
    />
  </svg>
);

const icon_approve = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C3.13473 0 0 3.13473 0 7C0 10.8653 3.13473 14 7 14C10.8653 14 14 10.8653 14 7C14 3.13473 10.8653 0 7 0ZM6.04545 9.86364L3.18182 7L4.13636 6.04545L6.04545 7.95455L9.83564 4.16436L10.7902 5.06355L6.04545 9.86364Z"
      fill="#A6B0CF"
    />
  </svg>
);

const icon_close = (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10.0942"
      y="0.662109"
      width="2.66667"
      height="13.3333"
      transform="rotate(45 10.0942 0.662109)"
      fill="white"
    />
    <rect
      x="0.761719"
      y="2.54883"
      width="2.66667"
      height="13.3333"
      transform="rotate(-45 0.761719 2.54883)"
      fill="white"
    />
  </svg>
);

const icon_mic = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 11.625C9.69575 11.6235 10.3626 11.3321 10.8546 10.8146C11.3466 10.297 11.6236 9.59553 11.625 8.86364V4.26136C11.625 3.529 11.3484 2.82664 10.8562 2.30878C10.3639 1.79093 9.69619 1.5 9 1.5C8.30381 1.5 7.63613 1.79093 7.14385 2.30878C6.65156 2.82664 6.375 3.529 6.375 4.26136V8.86364C6.37643 9.59553 6.65345 10.297 7.14542 10.8146C7.6374 11.3321 8.30425 11.6235 9 11.625Z"
      fill="#00CB82"
    />
    <path
      d="M13.4318 7.125H12.9887C12.8712 7.125 12.7584 7.17229 12.6753 7.25648C12.5922 7.34066 12.5455 7.45484 12.5455 7.57389V8.92057C12.5457 9.42267 12.442 9.91923 12.241 10.3782C12.04 10.8372 11.7462 11.2483 11.3786 11.5852C11.011 11.922 10.5778 12.177 10.1069 12.3338C9.63596 12.4905 9.13783 12.5454 8.64464 12.4951C7.75284 12.3781 6.93475 11.9327 6.34646 11.2437C5.75817 10.5548 5.44083 9.67063 5.455 8.75985V7.57389C5.455 7.45484 5.40831 7.34066 5.3252 7.25648C5.24209 7.17229 5.12938 7.125 5.01184 7.125H4.56869C4.45115 7.125 4.33843 7.17229 4.25533 7.25648C4.17222 7.34066 4.12553 7.45484 4.12553 7.57389V8.68227C4.10809 9.90155 4.52312 11.0867 5.29518 12.0223C6.06724 12.9579 7.14508 13.5819 8.33279 13.7808V14.7395H6.81183C6.6943 14.7395 6.58158 14.7868 6.49847 14.871C6.41536 14.9552 6.36867 15.0694 6.36867 15.1884V15.6373C6.36335 15.6994 6.37087 15.762 6.39074 15.821C6.41062 15.8801 6.44242 15.9342 6.48411 15.9801C6.52581 16.026 6.57648 16.0626 6.6329 16.0875C6.68933 16.1125 6.75027 16.1252 6.81183 16.125H11.2434C11.3609 16.125 11.4737 16.0777 11.5568 15.9935C11.6399 15.9093 11.6866 15.7952 11.6866 15.6761V15.2272C11.6866 15.1082 11.6399 14.994 11.5568 14.9098C11.4737 14.8256 11.3609 14.7783 11.2434 14.7783H9.66774V13.8085C10.8328 13.6442 11.9001 13.0591 12.6732 12.161C13.4463 11.2629 13.873 10.1121 13.875 8.92057V7.57389C13.875 7.45484 13.8283 7.34066 13.7452 7.25648C13.6621 7.17229 13.5494 7.125 13.4318 7.125Z"
      fill="#00CB82"
    />
  </svg>
);

const icon_print = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 5.33333H3.33333C2.22667 5.33333 1.33333 6.22667 1.33333 7.33333V10C1.33333 10.7333 1.93333 11.3333 2.66667 11.3333H4V12.6667C4 13.4 4.6 14 5.33333 14H10.6667C11.4 14 12 13.4 12 12.6667V11.3333H13.3333C14.0667 11.3333 14.6667 10.7333 14.6667 10V7.33333C14.6667 6.22667 13.7733 5.33333 12.6667 5.33333ZM10 12.6667H6C5.63333 12.6667 5.33333 12.3667 5.33333 12V9.33333H10.6667V12C10.6667 12.3667 10.3667 12.6667 10 12.6667ZM12.6667 8C12.3 8 12 7.7 12 7.33333C12 6.96667 12.3 6.66667 12.6667 6.66667C13.0333 6.66667 13.3333 6.96667 13.3333 7.33333C13.3333 7.7 13.0333 8 12.6667 8ZM11.3333 2H4.66667C4.3 2 4 2.3 4 2.66667V4C4 4.36667 4.3 4.66667 4.66667 4.66667H11.3333C11.7 4.66667 12 4.36667 12 4V2.66667C12 2.3 11.7 2 11.3333 2Z"
      fill="white"
    />
  </svg>
);

const icon_export = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.11111 10.8235V11.1765C5.42633 9.35671 6.91111 8.38612 8.77778 8.35294V10.4706C8.77778 10.8595 9.17522 11.1765 9.66678 11.1765C9.94989 11.1765 10.1918 11.0649 10.3536 10.9005C11.857 9.46824 15 6.58824 15 6.58824C15 6.58824 11.857 3.70682 10.3528 2.25624C10.1698 2.09267 9.92357 2.00068 9.66678 2C9.17522 2 8.77778 2.31553 8.77778 2.70588V4.82353C5.15333 4.82353 4.11111 8.26188 4.11111 10.8235ZM1.77778 14H12.6667C12.8729 14 13.0708 13.9256 13.2166 13.7933C13.3625 13.6609 13.4444 13.4813 13.4444 13.2941V9.02635C12.928 9.50353 12.3836 10.0096 11.8889 10.4713V12.5882H2.55556V4.11765H8V2.70588H1.77778C1.5715 2.70588 1.37367 2.78025 1.22781 2.91263C1.08194 3.04501 1 3.22455 1 3.41176V13.2941C1 13.4813 1.08194 13.6609 1.22781 13.7933C1.37367 13.9256 1.5715 14 1.77778 14Z"
      fill="white"
    />
  </svg>
);

const icon_transfer = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.26668 13.6003L13.9 8.61367C14.44 8.38034 14.44 7.62034 13.9 7.387L2.26668 2.40034C1.82668 2.207 1.34001 2.53367 1.34001 3.007L1.33334 6.08034C1.33334 6.41367 1.58001 6.70034 1.91334 6.74034L11.3333 8.00034L1.91334 9.25367C1.58001 9.30034 1.33334 9.587 1.33334 9.92034L1.34001 12.9937C1.34001 13.467 1.82668 13.7937 2.26668 13.6003Z"
      fill="white"
    />
  </svg>
);

const icon_address = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6067 3.92675L10.94 2.72675H10.3933L8 3.80008L5.60666 2.72675H5.57333L5.49333 2.66675H5.09333L2.42666 3.86675C2.29366 3.91771 2.18047 4.00994 2.10369 4.12991C2.02691 4.24988 1.99057 4.39129 2 4.53341V12.6667C2.00018 12.7783 2.02836 12.888 2.08193 12.9858C2.13551 13.0837 2.21278 13.1665 2.30666 13.2267C2.41397 13.2961 2.53892 13.3331 2.66666 13.3334C2.76099 13.333 2.85416 13.3125 2.94 13.2734L5.33333 12.2001L7.72667 13.2734H7.76C7.83513 13.3085 7.91706 13.3267 8 13.3267C8.08294 13.3267 8.16487 13.3085 8.24 13.2734H8.27333L10.6667 12.2001L13.06 13.2734C13.1458 13.3125 13.239 13.333 13.3333 13.3334C13.4611 13.3331 13.586 13.2961 13.6933 13.2267C13.7872 13.1665 13.8645 13.0837 13.9181 12.9858C13.9716 12.888 13.9998 12.7783 14 12.6667V4.53341C13.9997 4.40517 13.9625 4.27973 13.8927 4.17213C13.823 4.06452 13.7236 3.97933 13.6067 3.92675ZM6 4.36675L7.33333 4.96008V11.6267L6 11.0334V4.36675ZM12.6667 11.6334L11.3333 11.0401V4.37341L12.6667 4.96675V11.6334Z"
      fill="#9AB1CC"
    />
  </svg>
);
const icon_code = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.9 4H6.6C6.8 4.6 7.35 5 8 5C8.65 5 9.2 4.6 9.4 4H11.1C11.3 4.6 11.85 5 12.5 5C13.35 5 14 4.35 14 3.5C14 2.65 13.35 2 12.5 2C11.85 2 11.3 2.4 11.1 3H9.4C9.2 2.4 8.65 2 8 2C7.35 2 6.8 2.4 6.6 3H4.9C4.7 2.4 4.15 2 3.5 2C2.65 2 2 2.65 2 3.5C2 4.15 2.4 4.7 3 4.9V6.6C2.4 6.8 2 7.35 2 8C2 8.85 2.65 9.5 3.5 9.5C4.15 9.5 4.7 9.1 4.9 8.5H6.6C6.8 9.1 7.35 9.5 8 9.5C8.65 9.5 9.2 9.1 9.4 8.5H11.1C11.25 8.9 11.6 9.25 12 9.4V11.1C11.6 11.25 11.25 11.6 11.1 12H9.4C9.2 11.4 8.65 11 8 11C7.35 11 6.8 11.4 6.6 12H4.9C4.7 11.4 4.15 11 3.5 11C2.65 11 2 11.65 2 12.5C2 13.35 2.65 14 3.5 14C4.15 14 4.7 13.6 4.9 13H6.6C6.8 13.6 7.35 14 8 14C8.65 14 9.2 13.6 9.4 13H11.1C11.3 13.6 11.85 14 12.5 14C13.35 14 14 13.35 14 12.5C14 11.85 13.6 11.3 13 11.1V9.4C13.6 9.2 14 8.65 14 8C14 7.15 13.35 6.5 12.5 6.5C11.85 6.5 11.3 6.9 11.1 7.5H9.4C9.2 6.9 8.65 6.5 8 6.5C7.35 6.5 6.8 6.9 6.6 7.5H4.9C4.75 7.1 4.4 6.75 4 6.6V4.9C4.4 4.75 4.75 4.4 4.9 4Z"
      fill="#9AB1CC"
    />
  </svg>
);
const icon_company = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.76 13.4399H12.8V4.79992C12.8047 4.72993 12.7859 4.66037 12.7464 4.60236C12.707 4.54435 12.6492 4.50124 12.5824 4.47992L10.24 3.50072V13.4399H9.6V2.23992C9.6 2.15505 9.56628 2.07366 9.50627 2.01365C9.44626 1.95364 9.36487 1.91992 9.28 1.91992H3.52C3.43513 1.91992 3.35374 1.95364 3.29372 2.01365C3.23371 2.07366 3.2 2.15505 3.2 2.23992V13.4399H2.24C2.15513 13.4399 2.07374 13.4736 2.01372 13.5336C1.95371 13.5937 1.92 13.6751 1.92 13.7599C1.92 13.8448 1.95371 13.9262 2.01372 13.9862C2.07374 14.0462 2.15513 14.0799 2.24 14.0799H13.76C13.8449 14.0799 13.9263 14.0462 13.9863 13.9862C14.0463 13.9262 14.08 13.8448 14.08 13.7599C14.08 13.6751 14.0463 13.5937 13.9863 13.5336C13.9263 13.4736 13.8449 13.4399 13.76 13.4399ZM11.2 5.75992H11.84C11.9249 5.75992 12.0063 5.79364 12.0663 5.85365C12.1263 5.91366 12.16 5.99505 12.16 6.07992C12.1584 6.16428 12.1241 6.24472 12.0645 6.30438C12.0048 6.36404 11.9244 6.39828 11.84 6.39992H11.2C11.1156 6.39828 11.0352 6.36404 10.9755 6.30438C10.9159 6.24472 10.8816 6.16428 10.88 6.07992C10.88 5.99505 10.9137 5.91366 10.9737 5.85365C11.0337 5.79364 11.1151 5.75992 11.2 5.75992ZM11.2 7.67992H11.84C11.9249 7.67992 12.0063 7.71364 12.0663 7.77365C12.1263 7.83366 12.16 7.91505 12.16 7.99992C12.16 8.08479 12.1263 8.16618 12.0663 8.2262C12.0063 8.28621 11.9249 8.31992 11.84 8.31992H11.2C11.1151 8.31992 11.0337 8.28621 10.9737 8.2262C10.9137 8.16618 10.88 8.08479 10.88 7.99992C10.88 7.91505 10.9137 7.83366 10.9737 7.77365C11.0337 7.71364 11.1151 7.67992 11.2 7.67992ZM11.2 9.59992H11.84C11.9244 9.60156 12.0048 9.6358 12.0645 9.69546C12.1241 9.75512 12.1584 9.83557 12.16 9.91992C12.16 10.0048 12.1263 10.0862 12.0663 10.1462C12.0063 10.2062 11.9249 10.2399 11.84 10.2399H11.2C11.1151 10.2399 11.0337 10.2062 10.9737 10.1462C10.9137 10.0862 10.88 10.0048 10.88 9.91992C10.8816 9.83557 10.9159 9.75512 10.9755 9.69546C11.0352 9.6358 11.1156 9.60156 11.2 9.59992ZM11.2 11.5199H11.84C11.9249 11.5199 12.0063 11.5536 12.0663 11.6136C12.1263 11.6737 12.16 11.7551 12.16 11.8399C12.16 11.9248 12.1263 12.0062 12.0663 12.0662C12.0063 12.1262 11.9249 12.1599 11.84 12.1599H11.2C11.1151 12.1599 11.0337 12.1262 10.9737 12.0662C10.9137 12.0062 10.88 11.9248 10.88 11.8399C10.88 11.7551 10.9137 11.6737 10.9737 11.6136C11.0337 11.5536 11.1151 11.5199 11.2 11.5199ZM7.04 3.83992H7.68C7.76487 3.83992 7.84626 3.87364 7.90627 3.93365C7.96628 3.99366 8 4.07505 8 4.15992C8 4.24479 7.96628 4.32618 7.90627 4.3862C7.84626 4.44621 7.76487 4.47992 7.68 4.47992H7.04C6.95513 4.47992 6.87374 4.44621 6.81372 4.3862C6.75371 4.32618 6.72 4.24479 6.72 4.15992C6.72 4.07505 6.75371 3.99366 6.81372 3.93365C6.87374 3.87364 6.95513 3.83992 7.04 3.83992ZM7.04 5.75992H7.68C7.76487 5.75992 7.84626 5.79364 7.90627 5.85365C7.96628 5.91366 8 5.99505 8 6.07992C8 6.16479 7.96628 6.24618 7.90627 6.3062C7.84626 6.36621 7.76487 6.39992 7.68 6.39992H7.04C6.95513 6.39992 6.87374 6.36621 6.81372 6.3062C6.75371 6.24618 6.72 6.16479 6.72 6.07992C6.72 5.99505 6.75371 5.91366 6.81372 5.85365C6.87374 5.79364 6.95513 5.75992 7.04 5.75992ZM7.04 7.67992H7.68C7.76487 7.67992 7.84626 7.71364 7.90627 7.77365C7.96628 7.83366 8 7.91505 8 7.99992C8 8.08479 7.96628 8.16618 7.90627 8.2262C7.84626 8.28621 7.76487 8.31992 7.68 8.31992H7.04C6.95513 8.31992 6.87374 8.28621 6.81372 8.2262C6.75371 8.16618 6.72 8.08479 6.72 7.99992C6.72 7.91505 6.75371 7.83366 6.81372 7.77365C6.87374 7.71364 6.95513 7.67992 7.04 7.67992ZM7.04 9.59992H7.68C7.76487 9.59992 7.84626 9.63364 7.90627 9.69365C7.96628 9.75366 8 9.83505 8 9.91992C8 10.0048 7.96628 10.0862 7.90627 10.1462C7.84626 10.2062 7.76487 10.2399 7.68 10.2399H7.04C6.95513 10.2399 6.87374 10.2062 6.81372 10.1462C6.75371 10.0862 6.72 10.0048 6.72 9.91992C6.72 9.83505 6.75371 9.75366 6.81372 9.69365C6.87374 9.63364 6.95513 9.59992 7.04 9.59992ZM5.0816 3.83992H5.76C5.84487 3.83992 5.92626 3.87364 5.98627 3.93365C6.04628 3.99366 6.08 4.07505 6.08 4.15992C6.08 4.24479 6.04628 4.32618 5.98627 4.3862C5.92626 4.44621 5.84487 4.47992 5.76 4.47992H5.12C5.03513 4.47992 4.95374 4.44621 4.89372 4.3862C4.83371 4.32618 4.8 4.24479 4.8 4.15992C4.8 4.07505 4.83371 3.99366 4.89372 3.93365C4.95374 3.87364 5.03513 3.83992 5.12 3.83992H5.0816ZM5.0816 5.75992H5.76C5.84487 5.75992 5.92626 5.79364 5.98627 5.85365C6.04628 5.91366 6.08 5.99505 6.08 6.07992C6.08 6.16479 6.04628 6.24618 5.98627 6.3062C5.92626 6.36621 5.84487 6.39992 5.76 6.39992H5.12C5.03513 6.39992 4.95374 6.36621 4.89372 6.3062C4.83371 6.24618 4.8 6.16479 4.8 6.07992C4.8 5.99505 4.83371 5.91366 4.89372 5.85365C4.95374 5.79364 5.03513 5.75992 5.12 5.75992H5.0816ZM5.0816 7.67992H5.76C5.84487 7.67992 5.92626 7.71364 5.98627 7.77365C6.04628 7.83366 6.08 7.91505 6.08 7.99992C6.08 8.08479 6.04628 8.16618 5.98627 8.2262C5.92626 8.28621 5.84487 8.31992 5.76 8.31992H5.12C5.03513 8.31992 4.95374 8.28621 4.89372 8.2262C4.83371 8.16618 4.8 8.08479 4.8 7.99992C4.8 7.91505 4.83371 7.83366 4.89372 7.77365C4.95374 7.71364 5.03513 7.67992 5.12 7.67992H5.0816ZM5.0816 9.59992H5.76C5.84487 9.59992 5.92626 9.63364 5.98627 9.69365C6.04628 9.75366 6.08 9.83505 6.08 9.91992C6.08 10.0048 6.04628 10.0862 5.98627 10.1462C5.92626 10.2062 5.84487 10.2399 5.76 10.2399H5.12C5.03513 10.2399 4.95374 10.2062 4.89372 10.1462C4.83371 10.0862 4.8 10.0048 4.8 9.91992C4.8 9.83505 4.83371 9.75366 4.89372 9.69365C4.95374 9.63364 5.03513 9.59992 5.12 9.59992H5.0816ZM6.72 13.4399V12.1599H6.08V13.4399H5.44V11.8207C5.4449 11.7392 5.48076 11.6627 5.54025 11.6068C5.59974 11.5508 5.67835 11.5198 5.76 11.5199H7.04C7.12487 11.5199 7.20626 11.5536 7.26627 11.6136C7.32628 11.6737 7.36 11.7551 7.36 11.8399V13.4399H6.72Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_date = (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 0.828125V2.16146H1.33333C0.6 2.16146 0 2.76146 0 3.49479V12.8281C0 13.5615 0.6 14.1615 1.33333 14.1615H10.6667C11.4 14.1615 12 13.5615 12 12.8281V3.49479C12 2.76146 11.4 2.16146 10.6667 2.16146H10V0.828125H8.66667V2.16146H3.33333V0.828125H2ZM1.33333 5.49479H10.6667V12.8281H1.33333V5.49479Z"
      fill="#9AB1CC"
    />
  </svg>
);
const icon_link = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66668 10.0001H4.66668C3.53334 10.0001 2.66668 9.13341 2.66668 8.00008C2.66668 6.86675 3.53334 6.00008 4.66668 6.00008H6.66668C7.06668 6.00008 7.33334 5.73341 7.33334 5.33341C7.33334 4.93341 7.06668 4.66675 6.66668 4.66675H4.66668C2.80001 4.66675 1.33334 6.13341 1.33334 8.00008C1.33334 9.86675 2.80001 11.3334 4.66668 11.3334H6.66668C7.06668 11.3334 7.33334 11.0667 7.33334 10.6667C7.33334 10.2667 7.06668 10.0001 6.66668 10.0001ZM11.3333 4.66675H9.33334C8.93334 4.66675 8.66668 4.93341 8.66668 5.33341C8.66668 5.73341 8.93334 6.00008 9.33334 6.00008H11.3333C12.4667 6.00008 13.3333 6.86675 13.3333 8.00008C13.3333 9.13341 12.4667 10.0001 11.3333 10.0001H9.33334C8.93334 10.0001 8.66668 10.2667 8.66668 10.6667C8.66668 11.0667 8.93334 11.3334 9.33334 11.3334H11.3333C13.2 11.3334 14.6667 9.86675 14.6667 8.00008C14.6667 6.13341 13.2 4.66675 11.3333 4.66675ZM5.33334 8.00008C5.33334 8.40008 5.60001 8.66675 6.00001 8.66675H10C10.4 8.66675 10.6667 8.40008 10.6667 8.00008C10.6667 7.60008 10.4 7.33341 10 7.33341H6.00001C5.60001 7.33341 5.33334 7.60008 5.33334 8.00008Z"
      fill="#9AB1CC"
    />
  </svg>
);
const icon_men = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.98113 12.9614L6.53459 11.6227L5.18688 10.3803L6.98383 10.1266L9.00539 9.84657L9.26595 9.34785H9.24798C9.04176 9.34794 8.84179 9.27895 8.68162 9.15245C8.52146 9.02596 8.41085 8.84966 8.36837 8.65315C8.36748 8.11331 9.08625 8.28829 9.65229 7.37835C9.72417 7.36085 12.186 1 7.15454 1C2.12309 1 4.58491 7.36085 4.58491 7.36085C5.15094 8.2358 5.87871 8.10456 5.86972 8.62952C5.86074 9.15449 5.20485 9.32948 4.58491 9.39073C3.56065 9.50447 2.66217 9.27698 1.7637 10.9306C1.22462 11.8843 1 14.9991 1 14.9991H7.61276V14.8504L7.98113 12.9614ZM10.4969 15H11L10.7484 14.8775L10.4969 15Z"
      fill="#9AB1CC"
    />
    <path
      d="M10.5 13.8035L12.6613 15L12.25 12.4657L14 10.6756L11.585 10.3082L10.5 8L9.415 10.3082L7 10.6756L8.75 12.4657L8.33875 15L10.5 13.8035Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_name = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 13.3333H3.33335C3.15654 13.3333 2.98697 13.4036 2.86194 13.5286C2.73692 13.6536 2.66668 13.8232 2.66668 14C2.66668 14.1768 2.73692 14.3464 2.86194 14.4714C2.98697 14.5964 3.15654 14.6667 3.33335 14.6667H12.6667C12.8435 14.6667 13.0131 14.5964 13.1381 14.4714C13.2631 14.3464 13.3333 14.1768 13.3333 14C13.3333 13.8232 13.2631 13.6536 13.1381 13.5286C13.0131 13.4036 12.8435 13.3333 12.6667 13.3333ZM3.33335 12H3.39335L6.17335 11.7467C6.47788 11.7163 6.7627 11.5821 6.98001 11.3667L12.98 5.36665C13.2129 5.12063 13.3387 4.79233 13.33 4.45368C13.3213 4.11503 13.1786 3.79366 12.9333 3.55999L11.1067 1.73332C10.8683 1.50938 10.5559 1.38089 10.2289 1.37229C9.90193 1.36368 9.5832 1.47557 9.33335 1.68665L3.33335 7.68665C3.11786 7.90396 2.98368 8.18879 2.95335 8.49332L2.66668 11.2733C2.6577 11.371 2.67037 11.4694 2.70379 11.5616C2.73721 11.6538 2.79055 11.7374 2.86001 11.8067C2.92231 11.8684 2.99619 11.9173 3.07741 11.9505C3.15864 11.9837 3.24561 12.0005 3.33335 12ZM10.18 2.66665L12 4.48665L10.6667 5.78665L8.88001 3.99999L10.18 2.66665Z"
      fill="#9AB1CC"
    />
  </svg>
);
const icon_person = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.823 10.3677C3.66966 10.3457 3.50667 10.3334 3.33333 10.3334C2.05667 10.3334 1.34367 11.0071 1.07033 11.3427C1.026 11.4004 1.00233 11.4711 1.00233 11.5441C1.00233 11.5461 1.00233 11.5481 1.002 11.5497C0.999999 11.6731 1 11.8364 1 12.0001C1 12.1841 1.14933 12.3334 1.33333 12.3334H3.724C3.68633 12.2274 3.66667 12.1147 3.66667 12.0001C3.66667 11.6207 3.66667 11.1687 3.668 10.9017C3.668 10.7117 3.72233 10.5267 3.823 10.3677ZM11.3333 12.3334H4.66667C4.57833 12.3334 4.49333 12.2984 4.431 12.2357C4.36833 12.1734 4.33333 12.0884 4.33333 12.0001C4.33333 11.6217 4.33333 11.1717 4.33467 10.9037C4.33467 10.9031 4.33467 10.9024 4.33467 10.9017C4.33467 10.8251 4.36133 10.7511 4.40967 10.6917C4.82333 10.2194 6.07333 9.00008 8 9.00008C10.1807 9.00008 11.2757 10.2171 11.6107 10.6761C11.6477 10.7324 11.6667 10.7961 11.6667 10.8611V12.0001C11.6667 12.0884 11.6317 12.1734 11.569 12.2357C11.5067 12.2984 11.4217 12.3334 11.3333 12.3334ZM12.276 12.3334H14.6667C14.8507 12.3334 15 12.1841 15 12.0001V11.5437C15 11.4701 14.9757 11.3987 14.931 11.3404C14.6563 11.0071 13.943 10.3334 12.6667 10.3334C12.5023 10.3334 12.3473 10.3444 12.2013 10.3644C12.2877 10.5154 12.3333 10.6867 12.3333 10.8617V12.0001C12.3333 12.1147 12.3137 12.2274 12.276 12.3334ZM3.33333 6.33341C2.41333 6.33341 1.66667 7.08008 1.66667 8.00008C1.66667 8.92008 2.41333 9.66675 3.33333 9.66675C4.25333 9.66675 5 8.92008 5 8.00008C5 7.08008 4.25333 6.33341 3.33333 6.33341ZM12.6667 6.33341C11.7467 6.33341 11 7.08008 11 8.00008C11 8.92008 11.7467 9.66675 12.6667 9.66675C13.5867 9.66675 14.3333 8.92008 14.3333 8.00008C14.3333 7.08008 13.5867 6.33341 12.6667 6.33341ZM8 3.66675C6.71233 3.66675 5.66667 4.71241 5.66667 6.00008C5.66667 7.28775 6.71233 8.33341 8 8.33341C9.28767 8.33341 10.3333 7.28775 10.3333 6.00008C10.3333 4.71241 9.28767 3.66675 8 3.66675Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_phone = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20_3589)">
      <path
        d="M11.1499 9.5008C10.3249 9.4258 9.87492 10.5508 9.27492 10.8508C8.29992 11.3758 6.49992 9.5008 6.49992 9.5008C6.49992 9.5008 4.62492 7.7008 5.07492 6.7258C5.44992 6.1258 6.57492 5.6758 6.49992 4.8508C6.42492 4.1008 4.77492 1.4008 3.94992 2.1508C2.14992 3.8008 1.99992 4.4758 1.99992 5.8258C1.92492 8.1508 4.92492 11.0758 4.92492 11.0758C5.22492 11.3758 7.84992 14.0758 10.1749 14.0008C11.5249 14.0008 12.1999 13.8508 13.8499 12.0508C14.5999 11.2258 11.9749 9.5758 11.1499 9.5008Z"
        fill="#9AB1CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_20_3589">
        <rect width="12" height="12" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

const icon_shareholder = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.823 10.3675C3.66966 10.3455 3.50667 10.3332 3.33333 10.3332C2.05667 10.3332 1.34367 11.0068 1.07033 11.3425C1.026 11.4002 1.00233 11.4708 1.00233 11.5438C1.00233 11.5458 1.00233 11.5478 1.002 11.5495C0.999999 11.6728 1 11.8362 1 11.9998C1 12.1838 1.14933 12.3332 1.33333 12.3332H3.724C3.68633 12.2272 3.66667 12.1145 3.66667 11.9998C3.66667 11.6205 3.66667 11.1685 3.668 10.9015C3.668 10.7115 3.72233 10.5265 3.823 10.3675ZM11.3333 12.3332H4.66667C4.57833 12.3332 4.49333 12.2982 4.431 12.2355C4.36833 12.1732 4.33333 12.0882 4.33333 11.9998C4.33333 11.6215 4.33333 11.1715 4.33467 10.9035C4.33467 10.9028 4.33467 10.9022 4.33467 10.9015C4.33467 10.8248 4.36133 10.7508 4.40967 10.6915C4.82333 10.2192 6.07333 8.99984 8 8.99984C10.1807 8.99984 11.2757 10.2168 11.6107 10.6758C11.6477 10.7322 11.6667 10.7958 11.6667 10.8608V11.9998C11.6667 12.0882 11.6317 12.1732 11.569 12.2355C11.5067 12.2982 11.4217 12.3332 11.3333 12.3332ZM12.276 12.3332H14.6667C14.8507 12.3332 15 12.1838 15 11.9998V11.5435C15 11.4698 14.9757 11.3985 14.931 11.3402C14.6563 11.0068 13.943 10.3332 12.6667 10.3332C12.5023 10.3332 12.3473 10.3442 12.2013 10.3642C12.2877 10.5152 12.3333 10.6865 12.3333 10.8615V11.9998C12.3333 12.1145 12.3137 12.2272 12.276 12.3332ZM3.33333 6.33317C2.41333 6.33317 1.66667 7.07984 1.66667 7.99984C1.66667 8.91984 2.41333 9.6665 3.33333 9.6665C4.25333 9.6665 5 8.91984 5 7.99984C5 7.07984 4.25333 6.33317 3.33333 6.33317ZM12.6667 6.33317C11.7467 6.33317 11 7.07984 11 7.99984C11 8.91984 11.7467 9.6665 12.6667 9.6665C13.5867 9.6665 14.3333 8.91984 14.3333 7.99984C14.3333 7.07984 13.5867 6.33317 12.6667 6.33317ZM8 3.6665C6.71233 3.6665 5.66667 4.71217 5.66667 5.99984C5.66667 7.2875 6.71233 8.33317 8 8.33317C9.28767 8.33317 10.3333 7.2875 10.3333 5.99984C10.3333 4.71217 9.28767 3.6665 8 3.6665Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_time = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00001 1.33325C4.33334 1.33325 1.33334 4.33325 1.33334 7.99992C1.33334 11.6666 4.33334 14.6666 8.00001 14.6666C11.6667 14.6666 14.6667 11.6666 14.6667 7.99992C14.6667 4.33325 11.6667 1.33325 8.00001 1.33325ZM10 8.66659H8.00001C7.60001 8.66659 7.33334 8.39992 7.33334 7.99992V4.66659C7.33334 4.26659 7.60001 3.99992 8.00001 3.99992C8.40001 3.99992 8.66668 4.26659 8.66668 4.66659V7.33325H10C10.4 7.33325 10.6667 7.59992 10.6667 7.99992C10.6667 8.39992 10.4 8.66659 10 8.66659Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_women = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.60314 6.7878C8.60314 7.35038 8.38072 7.88992 7.98482 8.28772C7.58891 8.68553 7.05194 8.90901 6.49204 8.90901C5.93214 8.90901 5.39517 8.68553 4.99926 8.28772C4.60335 7.88992 4.38093 7.35038 4.38093 6.7878V4.66659C5.18537 4.56847 5.93126 4.19374 6.49204 3.60598C7.05282 4.19374 7.7987 4.56847 8.60314 4.66659V6.7878ZM4.68252 10.1211C4.76251 10.1211 4.83922 10.0892 4.89577 10.0324C4.95233 9.97555 4.98411 9.89847 4.98411 9.8181V9.05446C4.6131 8.80539 4.30892 8.46825 4.09851 8.07288C3.88809 7.67752 3.77793 7.23614 3.77776 6.7878V4.36355C3.77776 4.28319 3.80954 4.20611 3.86609 4.14928C3.92265 4.09245 3.99936 4.06052 4.07935 4.06052C4.49718 4.04182 4.90643 3.93504 5.28052 3.7471C5.65461 3.55915 5.98518 3.29426 6.25077 2.96962C6.27886 2.93198 6.31529 2.90143 6.35716 2.8804C6.39904 2.85936 6.44522 2.8484 6.49204 2.8484C6.53886 2.8484 6.58504 2.85936 6.62691 2.8804C6.66879 2.90143 6.70522 2.93198 6.73331 2.96962C6.9989 3.29426 7.32947 3.55915 7.70356 3.7471C8.07765 3.93504 8.4869 4.04182 8.90473 4.06052C8.98472 4.06052 9.06143 4.09245 9.11798 4.14928C9.17454 4.20611 9.20632 4.28319 9.20632 4.36355V6.7878C9.20615 7.23614 9.09599 7.67752 8.88557 8.07288C8.67516 8.46825 8.37098 8.80539 7.99997 9.05446V9.8181C7.99997 9.89847 8.03174 9.97555 8.0883 10.0324C8.14486 10.0892 8.22157 10.1211 8.30156 10.1211H9.80949C10.0152 10.1206 10.2194 10.1565 10.4127 10.2272V5.27265C10.4127 4.22785 9.9996 3.22585 9.26434 2.48707C8.52908 1.74829 7.53185 1.33325 6.49204 1.33325C5.45222 1.33325 4.455 1.74829 3.71974 2.48707C2.98448 3.22585 2.57142 4.22785 2.57142 5.27265V10.2272C2.7647 10.1565 2.96889 10.1206 3.17459 10.1211H4.68252ZM14.3333 4.66659C14.3346 4.58647 14.3042 4.50911 14.2488 4.45143L12.4393 2.63325C12.4108 2.6048 12.3769 2.58237 12.3396 2.56728C12.3023 2.55219 12.2624 2.54474 12.2222 2.54537H10.4127V3.15143H11.9206V4.66659C11.9206 4.74695 11.9524 4.82403 12.0089 4.88086C12.0655 4.93769 12.1422 4.96962 12.2222 4.96962H13.7301V10.4242H11.619V11.0302H14.0317C14.1117 11.0302 14.1884 10.9983 14.245 10.9415C14.3015 10.8846 14.3333 10.8076 14.3333 10.7272V4.66659ZM13.1269 6.18174H11.0158V6.7878H13.1269V6.18174ZM11.0158 7.99992H13.1269V7.39386H11.0158V7.99992ZM11.0158 9.21204H13.1269V8.60598H11.0158V9.21204ZM7.99997 10.7272V10.3454C7.90664 10.2935 7.82921 10.2169 7.77605 10.124C7.72289 10.031 7.69604 9.92526 7.69838 9.8181V9.21204C7.32345 9.39895 6.91058 9.4962 6.49204 9.4962C6.0735 9.4962 5.66063 9.39895 5.28569 9.21204V9.8181C5.28585 9.92322 5.25796 10.0265 5.20491 10.1171C5.15187 10.2077 5.07562 10.2823 4.98411 10.3333V10.7272C4.98411 11.1848 5.73204 11.6363 6.49204 11.6363C7.25204 11.6363 7.99997 11.1848 7.99997 10.7272ZM4.38093 10.7272V10.4242H3.17459C2.77466 10.4242 2.39111 10.5838 2.10832 10.8679C1.82553 11.1521 1.66666 11.5375 1.66666 11.9393V14.3636C1.66666 14.4439 1.69843 14.521 1.75499 14.5778C1.81155 14.6347 1.88826 14.6666 1.96824 14.6666H6.19045V12.2211C5.28569 12.1151 4.38093 11.5302 4.38093 10.7272ZM9.80949 10.4242H8.60314V10.7272C8.60314 11.5302 7.69838 12.1151 6.79362 12.2211V14.6666H11.0158C11.0958 14.6666 11.1725 14.6347 11.2291 14.5778C11.2856 14.521 11.3174 14.4439 11.3174 14.3636V11.9393C11.3174 11.5375 11.1586 11.1521 10.8758 10.8679C10.593 10.5838 10.2094 10.4242 9.80949 10.4242Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_account = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99996 7.99999C9.03274 7.99999 10.6802 6.35248 10.6802 4.3197C10.6802 2.28691 9.03274 0.639404 6.99996 0.639404C4.96717 0.639404 3.31967 2.28691 3.31967 4.3197C3.31967 6.35248 4.96717 7.99999 6.99996 7.99999ZM9.57616 8.92006H9.096C8.4577 9.21333 7.74752 9.3801 6.99996 9.3801C6.2524 9.3801 5.54509 9.21333 4.90392 8.92006H4.42375C2.29033 8.92006 0.559448 10.6509 0.559448 12.7844V13.9805C0.559448 14.7424 1.17762 15.3606 1.93956 15.3606H12.0604C12.8223 15.3606 13.4405 14.7424 13.4405 13.9805V12.7844C13.4405 10.6509 11.7096 8.92006 9.57616 8.92006Z"
      fill="#00CB82"
    />
  </svg>
);

const icon_file = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.565 1H3.065V15H12.92V4.88L8.565 1ZM4.75 10.865H6.5C6.59946 10.865 6.69484 10.9045 6.76517 10.9748C6.83549 11.0452 6.875 11.1405 6.875 11.24C6.875 11.3395 6.83549 11.4348 6.76517 11.5052C6.69484 11.5755 6.59946 11.615 6.5 11.615H4.75C4.65055 11.615 4.55516 11.5755 4.48484 11.5052C4.41451 11.4348 4.375 11.3395 4.375 11.24C4.375 11.1405 4.41451 11.0452 4.48484 10.9748C4.55516 10.9045 4.65055 10.865 4.75 10.865ZM9 13.365H4.75C4.65055 13.365 4.55516 13.3255 4.48484 13.2552C4.41451 13.1848 4.375 13.0895 4.375 12.99C4.375 12.8905 4.41451 12.7952 4.48484 12.7248C4.55516 12.6545 4.65055 12.615 4.75 12.615H9C9.09946 12.615 9.19484 12.6545 9.26517 12.7248C9.33549 12.7952 9.375 12.8905 9.375 12.99C9.375 13.0895 9.33549 13.1848 9.26517 13.2552C9.19484 13.3255 9.09946 13.365 9 13.365ZM8.565 5.03C8.54005 5.03 8.51534 5.02509 8.49229 5.01554C8.46924 5.00599 8.4483 4.99199 8.43065 4.97435C8.41301 4.95671 8.39901 4.93576 8.38946 4.91271C8.37992 4.88966 8.375 4.86495 8.375 4.84V1.84L11.965 5.025L8.565 5.03Z"
      fill="#9AB1CC"
    />
    <path
      d="M12.39 15.3749H3.61C3.34478 15.3749 3.09043 15.2695 2.90289 15.082C2.71536 14.8944 2.61 14.6401 2.61 14.3749V1.60986C2.61 1.34465 2.71536 1.09029 2.90289 0.902757C3.09043 0.71522 3.34478 0.609863 3.61 0.609863H7.94C8.0567 0.609863 8.16861 0.65622 8.25113 0.738736C8.33364 0.821252 8.38 0.933168 8.38 1.04986V4.85986C8.38 4.91025 8.40002 4.95858 8.43565 4.99421C8.47128 5.02985 8.51961 5.04986 8.57 5.04986H12.945C13.06 5.05116 13.1699 5.09741 13.2512 5.17871C13.3325 5.26001 13.3787 5.3699 13.38 5.48486V14.3899C13.3761 14.6508 13.2704 14.8998 13.0854 15.0838C12.9005 15.2678 12.6509 15.3723 12.39 15.3749ZM3.61 1.37486C3.54767 1.37486 3.4879 1.39962 3.44383 1.44369C3.39976 1.48776 3.375 1.54754 3.375 1.60986V14.3899C3.375 14.4522 3.39976 14.512 3.44383 14.556C3.4879 14.6001 3.54767 14.6249 3.61 14.6249H12.39C12.4523 14.6249 12.5121 14.6001 12.5562 14.556C12.6002 14.512 12.625 14.4522 12.625 14.3899V5.80986H8.565C8.31656 5.80854 8.07875 5.70892 7.90355 5.53278C7.72835 5.35664 7.63 5.1183 7.63 4.86986V1.36986L3.61 1.37486Z"
      fill="#9AB1CC"
    />
    <path
      d="M8.25023 0.759865L7.75238 1.3208L12.7522 5.75828L13.25 5.19734L8.25023 0.759865Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_map = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6067 3.92675L10.94 2.72675H10.3933L8 3.80008L5.60666 2.72675H5.57333L5.49333 2.66675H5.09333L2.42666 3.86675C2.29366 3.91771 2.18047 4.00994 2.10369 4.12991C2.02691 4.24988 1.99057 4.39129 2 4.53341V12.6667C2.00018 12.7783 2.02836 12.888 2.08193 12.9858C2.13551 13.0837 2.21278 13.1665 2.30666 13.2267C2.41397 13.2961 2.53892 13.3331 2.66666 13.3334C2.76099 13.333 2.85416 13.3125 2.94 13.2734L5.33333 12.2001L7.72667 13.2734H7.76C7.83513 13.3085 7.91706 13.3267 8 13.3267C8.08294 13.3267 8.16487 13.3085 8.24 13.2734H8.27333L10.6667 12.2001L13.06 13.2734C13.1458 13.3125 13.239 13.333 13.3333 13.3334C13.4611 13.3331 13.586 13.2961 13.6933 13.2267C13.7872 13.1665 13.8645 13.0837 13.9181 12.9858C13.9716 12.888 13.9998 12.7783 14 12.6667V4.53341C13.9997 4.40517 13.9625 4.27973 13.8927 4.17213C13.823 4.06452 13.7236 3.97933 13.6067 3.92675ZM6 4.36675L7.33333 4.96008V11.6267L6 11.0334V4.36675ZM12.6667 11.6334L11.3333 11.0401V4.37341L12.6667 4.96675V11.6334Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_edit = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 13.3333H3.33335C3.15654 13.3333 2.98697 13.4036 2.86194 13.5286C2.73692 13.6536 2.66668 13.8232 2.66668 14C2.66668 14.1768 2.73692 14.3464 2.86194 14.4714C2.98697 14.5964 3.15654 14.6667 3.33335 14.6667H12.6667C12.8435 14.6667 13.0131 14.5964 13.1381 14.4714C13.2631 14.3464 13.3333 14.1768 13.3333 14C13.3333 13.8232 13.2631 13.6536 13.1381 13.5286C13.0131 13.4036 12.8435 13.3333 12.6667 13.3333ZM3.33335 12H3.39335L6.17335 11.7467C6.47788 11.7163 6.7627 11.5821 6.98001 11.3667L12.98 5.36665C13.2129 5.12063 13.3387 4.79233 13.33 4.45368C13.3213 4.11503 13.1786 3.79366 12.9333 3.55999L11.1067 1.73332C10.8683 1.50938 10.5559 1.38089 10.2289 1.37229C9.90193 1.36368 9.5832 1.47557 9.33335 1.68665L3.33335 7.68665C3.11786 7.90396 2.98368 8.18879 2.95335 8.49332L2.66668 11.2733C2.6577 11.371 2.67037 11.4694 2.70379 11.5616C2.73721 11.6538 2.79055 11.7374 2.86001 11.8067C2.92231 11.8684 2.99619 11.9173 3.07741 11.9505C3.15864 11.9837 3.24561 12.0005 3.33335 12ZM10.18 2.66665L12 4.48665L10.6667 5.78665L8.88001 3.99999L10.18 2.66665Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_preside = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.98113 12.9614L6.53459 11.6227L5.18688 10.3803L6.98383 10.1266L9.00539 9.84657L9.26595 9.34785H9.24798C9.04176 9.34794 8.84179 9.27895 8.68162 9.15245C8.52146 9.02596 8.41085 8.84966 8.36837 8.65315C8.36748 8.11331 9.08625 8.28829 9.65229 7.37835C9.72417 7.36085 12.186 1 7.15454 1C2.12309 1 4.58491 7.36085 4.58491 7.36085C5.15094 8.2358 5.87871 8.10456 5.86972 8.62952C5.86074 9.15449 5.20485 9.32948 4.58491 9.39073C3.56065 9.50447 2.66217 9.27698 1.7637 10.9306C1.22462 11.8843 1 14.9991 1 14.9991H7.61276V14.8504L7.98113 12.9614ZM10.4969 15H11L10.7484 14.8775L10.4969 15Z"
      fill="#9AB1CC"
    />
    <path
      d="M10.5 13.8035L12.6613 15L12.25 12.4657L14 10.6756L11.585 10.3082L10.5 8L9.415 10.3082L7 10.6756L8.75 12.4657L8.33875 15L10.5 13.8035Z"
      fill="#9AB1CC"
    />
  </svg>
);

// const icon_edit = (
//   <svg
//     width="13"
//     height="16"
//     viewBox="0 0 13 16"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M12.25 14.0001H1.74998C1.55107 14.0001 1.3603 14.0792 1.21965 14.2198C1.079 14.3605 0.999978 14.5512 0.999978 14.7501C0.999978 14.949 1.079 15.1398 1.21965 15.2805C1.3603 15.4211 1.55107 15.5001 1.74998 15.5001H12.25C12.4489 15.5001 12.6397 15.4211 12.7803 15.2805C12.921 15.1398 13 14.949 13 14.7501C13 14.5512 12.921 14.3605 12.7803 14.2198C12.6397 14.0792 12.4489 14.0001 12.25 14.0001ZM1.74998 12.5001H1.81748L4.94498 12.2151C5.28758 12.181 5.608 12.0301 5.85248 11.7876L12.6025 5.03764C12.8645 4.76086 13.0061 4.39152 12.9962 4.01054C12.9864 3.62956 12.8259 3.26802 12.55 3.00514L10.495 0.950138C10.2268 0.69821 9.87532 0.553657 9.50748 0.543977C9.13963 0.534297 8.78106 0.660165 8.49998 0.897638L1.74998 7.64764C1.50755 7.89211 1.35661 8.21254 1.32248 8.55514L0.999978 11.6826C0.989875 11.7925 1.00413 11.9032 1.04172 12.0069C1.07932 12.1106 1.13933 12.2048 1.21748 12.2826C1.28756 12.3521 1.37067 12.4071 1.46205 12.4445C1.55343 12.4818 1.65127 12.5007 1.74998 12.5001ZM9.45248 2.00014L11.5 4.04764L9.99998 5.51014L7.98998 3.50014L9.45248 2.00014Z"
//       fill="#9AB1CC"
//     />
//   </svg>
// );

const icon_delete = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 12.25C1.5 13.075 2.175 13.75 3 13.75H9C9.825 13.75 10.5 13.075 10.5 12.25V4.75C10.5 3.925 9.825 3.25 9 3.25H3C2.175 3.25 1.5 3.925 1.5 4.75V12.25ZM3.8775 6.3775C4.17 6.085 4.6425 6.085 4.935 6.3775L6 7.4425L7.065 6.3775C7.3575 6.085 7.83 6.085 8.1225 6.3775C8.415 6.67 8.415 7.1425 8.1225 7.435L7.0575 8.5L8.1225 9.565C8.415 9.8575 8.415 10.33 8.1225 10.6225C7.83 10.915 7.3575 10.915 7.065 10.6225L6 9.5575L4.935 10.6225C4.6425 10.915 4.17 10.915 3.8775 10.6225C3.585 10.33 3.585 9.8575 3.8775 9.565L4.9425 8.5L3.8775 7.435C3.585 7.15 3.585 6.67 3.8775 6.3775ZM8.625 1L8.0925 0.4675C7.9575 0.3325 7.7625 0.25 7.5675 0.25H4.4325C4.2375 0.25 4.0425 0.3325 3.9075 0.4675L3.375 1H1.5C1.0875 1 0.75 1.3375 0.75 1.75C0.75 2.1625 1.0875 2.5 1.5 2.5H10.5C10.9125 2.5 11.25 2.1625 11.25 1.75C11.25 1.3375 10.9125 1 10.5 1H8.625Z"
      fill="#A6B0CF"
    />
  </svg>
);

const icon_sort = (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 9.5H8.5V8H5.5V9.5ZM0.25 0.5V2H13.75V0.5H0.25ZM2.5 5.75H11.5V4.25H2.5V5.75Z"
      fill="#333B6A"
    />
  </svg>
);
const icon_block = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.93069 0.738063C9.85516 0.662513 9.76548 0.602599 9.66677 0.561749C9.56806 0.5209 9.46227 0.499916 9.35544 0.5H4.64456C4.42925 0.5 4.22206 0.585313 4.07013 0.738063L0.738876 4.07013C0.663005 4.14529 0.60282 4.23477 0.561813 4.33338C0.520807 4.43199 0.499796 4.53777 0.500001 4.64456V9.35625C0.500001 9.57156 0.585314 9.77875 0.738064 9.93069L4.06931 13.2628C4.22206 13.4147 4.42844 13.5 4.64456 13.5H9.35625C9.57156 13.5 9.77875 13.4147 9.93069 13.2619L13.2619 9.92988C13.4147 9.77794 13.5 9.57156 13.5 9.35544V4.64456C13.5 4.42925 13.4147 4.22206 13.2619 4.07013L9.93069 0.738063ZM7 8.625C6.78451 8.625 6.57785 8.5394 6.42548 8.38702C6.2731 8.23465 6.1875 8.02799 6.1875 7.8125V2.9375C6.1875 2.72201 6.2731 2.51535 6.42548 2.36298C6.57785 2.2106 6.78451 2.125 7 2.125C7.21549 2.125 7.42215 2.2106 7.57453 2.36298C7.7269 2.51535 7.8125 2.72201 7.8125 2.9375V7.8125C7.8125 8.02799 7.7269 8.23465 7.57453 8.38702C7.42215 8.5394 7.21549 8.625 7 8.625ZM7.8125 11.0625C7.81247 11.1692 7.79143 11.2749 7.75056 11.3735C7.70969 11.4721 7.64981 11.5617 7.57432 11.6371C7.49884 11.7126 7.40923 11.7724 7.31062 11.8132C7.21201 11.854 7.10632 11.875 6.9996 11.875C6.89287 11.875 6.78719 11.8539 6.6886 11.8131C6.59001 11.7722 6.50043 11.7123 6.42499 11.6368C6.34954 11.5613 6.2897 11.4717 6.24888 11.3731C6.20806 11.2745 6.18707 11.1688 6.1871 11.0621C6.18715 10.8466 6.27282 10.6399 6.42527 10.4875C6.57772 10.3351 6.78446 10.2495 7 10.2496C7.21554 10.2496 7.42224 10.3353 7.57461 10.4878C7.72698 10.6402 7.81256 10.847 7.8125 11.0625Z"
      fill="#A6B0CF"
    />
  </svg>
);

const icon_lock = (
  <svg
    width="12"
    height="17"
    viewBox="0 0 12 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 6H9.75V4.5C9.75 2.43 8.07 0.75 6 0.75C3.93 0.75 2.25 2.43 2.25 4.5V6H1.5C0.67125 6 0 6.67125 0 7.5V15C0 15.8287 0.67125 16.5 1.5 16.5H10.5C11.3287 16.5 12 15.8287 12 15V7.5C12 6.67125 11.3287 6 10.5 6ZM6 12.75C5.17125 12.75 4.5 12.0787 4.5 11.25C4.5 10.4212 5.17125 9.75 6 9.75C6.82875 9.75 7.5 10.4212 7.5 11.25C7.5 12.0787 6.82875 12.75 6 12.75ZM8.325 6H3.675V4.5C3.675 3.2175 4.7175 2.175 6 2.175C7.2825 2.175 8.325 3.2175 8.325 4.5V6Z"
      fill="#A6B0CF"
    />
  </svg>
);
const icon_unlock = (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2188 5.53906H9.51562V4.13281C9.51562 2.19922 7.93359 0.617188 6 0.617188C4.06641 0.617188 2.48438 2.19922 2.48438 4.13281H3.82024C3.82024 2.93736 4.80472 1.95305 6 1.95305C7.19545 1.95305 8.17976 2.93736 8.17976 4.13281H8.17969V5.53906H1.78125C1.00774 5.53906 0.375 6.1718 0.375 6.94531V13.9766C0.375 14.7501 1.00774 15.3828 1.78125 15.3828H10.2188C10.9923 15.3828 11.625 14.7501 11.625 13.9766V6.94531C11.625 6.1718 10.9923 5.53906 10.2188 5.53906ZM6 11.9375C5.22649 11.9375 4.59375 11.3048 4.59375 10.5312C4.59375 9.75774 5.22649 9.125 6 9.125C6.77351 9.125 7.40625 9.75774 7.40625 10.5312C7.40625 11.3048 6.77351 11.9375 6 11.9375Z"
      fill="#A6B0CF"
    />
  </svg>
);

const icon_add = (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9688 5.64258V8.18555H0.273438V5.64258H11.9688ZM7.49219 0.861328V13.2832H4.76172V0.861328H7.49219Z"
      fill="#00CB82"
    />
  </svg>
);

const icon_user = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99994 8.77128C9.62617 8.77128 10.9442 7.45327 10.9442 5.82705C10.9442 4.20082 9.62617 2.88281 7.99994 2.88281C6.37371 2.88281 5.05571 4.20082 5.05571 5.82705C5.05571 7.45327 6.37371 8.77128 7.99994 8.77128ZM10.0609 9.50734H9.67677C9.16613 9.74196 8.59799 9.87537 7.99994 9.87537C7.40189 9.87537 6.83605 9.74196 6.32311 9.50734H5.93898C4.23224 9.50734 2.84753 10.892 2.84753 12.5988V13.5557C2.84753 14.1652 3.34207 14.6597 3.95162 14.6597H12.0483C12.6578 14.6597 13.1523 14.1652 13.1523 13.5557V12.5988C13.1523 10.892 11.7676 9.50734 10.0609 9.50734Z"
      fill="#00CB82"
    />
  </svg>
);
const icon_addModal = (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.52615 0.888672C3.40084 0.888672 0.0561523 4.23336 0.0561523 8.35867C0.0561523 12.484 3.40084 15.8287 7.52615 15.8287C11.6515 15.8287 14.9962 12.484 14.9962 8.35867C14.9962 4.23336 11.6515 0.888672 7.52615 0.888672ZM11.2612 8.98117H8.14865V12.0937C8.14865 12.4379 7.86977 12.7162 7.52615 12.7162C7.18253 12.7162 6.90365 12.4379 6.90365 12.0937V8.98117H3.79115C3.44753 8.98117 3.16865 8.70291 3.16865 8.35867C3.16865 8.01443 3.44753 7.73617 3.79115 7.73617H6.90365V4.62367C6.90365 4.27943 7.18253 4.00117 7.52615 4.00117C7.86977 4.00117 8.14865 4.27943 8.14865 4.62367V7.73617H11.2612C11.6048 7.73617 11.8837 8.01443 11.8837 8.35867C11.8837 8.70291 11.6048 8.98117 11.2612 8.98117Z"
      fill="#9AB1CC"
    />
  </svg>
);

const icon_import = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_34_20049)">
      <path
        d="M12.5472 11.7956V12.2083C11.0093 10.0805 9.2732 8.94562 7.09056 8.90682V11.3829C7.09056 11.8377 6.62584 12.2083 6.05108 12.2083C5.72005 12.2083 5.43721 12.0779 5.24805 11.8856C3.49012 10.2109 -0.184902 6.84341 -0.184902 6.84341C-0.184902 6.84341 3.49012 3.47425 5.24896 1.77812C5.46286 1.58687 5.75082 1.47931 6.05108 1.47852C6.62584 1.47852 7.09056 1.84745 7.09056 2.30388V4.77999C11.3285 4.77999 12.5472 8.80035 12.5472 11.7956ZM15.2755 15.5098H2.5434C2.3022 15.5098 2.07088 15.4228 1.90033 15.268C1.72978 15.1132 1.63396 14.9033 1.63396 14.6844V9.69423C2.23783 10.2522 2.87443 10.844 3.45283 11.3838V13.859H14.366V3.95462H7.99999V2.30388H15.2755C15.5167 2.30388 15.748 2.39084 15.9185 2.54563C16.0891 2.70041 16.1849 2.91035 16.1849 3.12925V14.6844C16.1849 14.9033 16.0891 15.1132 15.9185 15.268C15.748 15.4228 15.5167 15.5098 15.2755 15.5098Z"
        fill="#00CB82"
      />
    </g>
    <defs>
      <clipPath id="clip0_34_20049">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.494141)"
        />
      </clipPath>
    </defs>
  </svg>
);

const icon_accountpermiss = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.48824 0.0136719C4.91423 0.0136719 3.63824 1.28966 3.63824 2.86367C3.63824 4.43768 4.91423 5.71367 6.48824 5.71367C8.06226 5.71367 9.33824 4.43768 9.33824 2.86367C9.33824 1.28966 8.06226 0.0136719 6.48824 0.0136719ZM6.48824 7.85117C4.25028 7.85117 0.0757446 8.95198 0.0757446 11.0574V12.8387H6.69838C6.62926 12.6078 6.57604 12.3698 6.54113 12.1262H6.5453C6.51181 11.8932 6.48824 11.6559 6.48824 11.4137C6.48824 10.6463 6.66744 9.92248 6.97809 9.27339C7.20894 8.78889 7.51148 8.34511 7.87985 7.9625C7.3754 7.8884 6.89936 7.85117 6.48824 7.85117ZM10.8092 7.85117C10.7173 7.85117 10.6403 7.92001 10.6297 8.01121L10.5462 8.73206C10.2013 8.85176 9.8901 9.03341 9.61935 9.26782L8.95138 8.97837C8.8673 8.94203 8.77015 8.97511 8.72455 9.05491L8.05658 10.2099C8.01098 10.2897 8.0319 10.391 8.10529 10.4451L8.68002 10.8709C8.64653 11.0476 8.62574 11.2284 8.62574 11.4137C8.62574 11.5989 8.64582 11.779 8.68002 11.955L8.10668 12.3822C8.03329 12.4371 8.01166 12.5383 8.05797 12.6174L8.72455 13.7724C8.77015 13.8522 8.8687 13.8839 8.95277 13.8476L9.61935 13.5595C9.88939 13.7932 10.2013 13.9756 10.5462 14.0953L10.6297 14.8161C10.6396 14.9081 10.7173 14.9762 10.8092 14.9762H12.1423C12.2342 14.9762 12.3112 14.9073 12.3218 14.8161L12.4053 14.0953C12.7502 13.9756 13.0614 13.7939 13.3321 13.5595L14.0001 13.849C14.0842 13.8853 14.1813 13.8515 14.2269 13.7724L14.8949 12.6174C14.9405 12.5376 14.9196 12.4364 14.8462 12.3822L14.2715 11.955C14.3057 11.779 14.3257 11.5989 14.3257 11.4137C14.3257 11.2284 14.3057 11.0483 14.2715 10.8723L14.8448 10.4451C14.9182 10.3903 14.9398 10.289 14.8935 10.2099L14.2269 9.05491C14.1813 8.97511 14.0828 8.94342 13.9987 8.97976L13.3321 9.26782C13.0621 9.03412 12.7502 8.85176 12.4053 8.73206L12.3218 8.01121C12.3119 7.91929 12.2342 7.85117 12.1423 7.85117H10.8092ZM11.4757 10.1668C12.164 10.1668 12.7226 10.7247 12.7226 11.4137C12.7226 12.1019 12.164 12.6605 11.4757 12.6605C10.7875 12.6605 10.2289 12.1019 10.2289 11.4137C10.2289 10.7247 10.7875 10.1668 11.4757 10.1668Z"
      fill="#9AB1CC"
    />
  </svg>
);

const inputIcons = {
  // file: icon_file,
  addModal: icon_addModal,
  add: icon_add,
  email: icon_email,
  print: icon_print,
  export: icon_export,
  export_result: icon_export_result,
  transfer: icon_transfer,
  address: icon_address,
  code: icon_code,
  company: icon_company,
  date: icon_date,
  link: icon_link,
  men: icon_men,
  name: icon_name,
  person: icon_person,
  phone: icon_phone,
  shareholder: icon_shareholder,
  time: icon_time,
  women: icon_women,
  account: icon_account,
  delete: icon_delete,
  sort: icon_sort,
  edit: icon_edit,
  block: icon_block,
  lock: icon_lock,
  unlock: icon_unlock,
  file: icon_file,
  map: icon_map,
  approve: icon_approve,
  // edit: icon_edit,
  preside: icon_preside,
  chat: icon_chat,
  mic: icon_mic,
  close: icon_close,
  refuse: icon_refuse,
  upload: icon_upload,
  download: icon_download,
  plus: icon_plus,
  eye: icon_eye,
  user: icon_user,
  import: icon_import,
  accountpermiss: icon_accountpermiss,
};

export default inputIcons;
